import axios from "axios";
import store from "@/store";
import { i18n } from "@v2/shared/config";
import getError from "@/helpers/error";

axios.interceptors.request.use(function(config) {
  config.baseURL = `${process.env.VUE_APP_URL}api/`;
  config.headers.Authorization = `Bearer ${store.getters["auth/token"]}`;
  config.headers["Accept-Language"] = i18n.locale;
  return config;
});

axios.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    const status = error?.response?.status;

    if (status === 401) {
      store.dispatch("auth/logout");
      return Promise.reject(error);
    }

    if (status === 422 || status === 403) {
      return Promise.reject({
        error_code: "axios",
        error_data: error
      });
    }

    // store.dispatch(
    //   "common/setErrorMessage",
    //   getError({
    //     error_code: "axios",
    //     error_data: error
    //   })
    // );
    return Promise.reject(error);
  }
);

export { axios };
